export default __webpack_public_path__ + "static/online-study-desks-982c637191423f652a568d0c9414efae.png";